import List from '../modules/quote_table/list'

declare var MobileSelect;
declare var Swiper;

var data = {
    timer:null,
    refresh_time:10,
    quotaConfig: {
        host: '//push2.eastmoney.com',
        unpPath: '/api/qt/ulist.np/get',
        token: 'f057cbcbce2a86e2866ab8877db1d059',
        cPath: '/api/qt/clist/get'
    },
    init:function(){
        let self = this
        self.getData(self.getyingguzhishu(), self.bindSwiperData);
        self.bindHltyj()
        self.makeList1()
        self.makeList2()
        self.makeList3()
        self.makeList4()
        self.makeList5()
        self.refresh()
    },
    // 英股指数 Ajax 请求地址
    getyingguzhishu: function () {
          let self = this
          let ids = "100.FTSE,100.MCX,100.AXX";
          let url = self.quotaConfig.host + self.quotaConfig.unpPath
              + "?fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&secids=" + ids
              + "&ut=" + self.quotaConfig.token + "&forcect=1";
          return url
    },
    // Ajax 请求
    getData: function (url, callback) {
        let self = this
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                //-> data: 就是我们从服务器获取的数据，然后执行第四步的bindHTML方法
                callback(data,self)
            }
        })
    },
    // 给 Swiper 绑定数据
    bindSwiperData: function (data,self) {
        if (data.rc == 0) {
            let _class = ''
            let _siwper_html = ''
            data.data.diff.forEach((item, index) => {
                if (index == 0) {
                    _class = 'swiper-slide swiper-slide-active'
                } else if (index == 1) {
                    _class = 'swiper-slide swiper-slide-next'
                } else {
                    _class = 'swiper-slide'
                }
                _siwper_html += `<div class="${_class}">
                            <div class="zs-wrap">
                                <a href="/quote/stock/${item.f13}.${item.f12}.html">
                                    <p>${item.f14}</p>
                                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>${self.numberFix(item.f2,2)}</p>
                                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>
                                        <span>${self.numberFix(item.f4,2)}</span>
                                        <span>${self.dataProcess(item.f3,'%')}</span>
                                    </p>
                                </a>
                            </div>
                        </div>`
            })
            $('#yingguzhishu').html(_siwper_html)
            let swiper = new Swiper('.hk-swiper', {
                direction: 'horizontal',
                slidesPerGroup: 3,
                slidesPerView: 3,
                spaceBetween: 10,
                navigation: {
                    nextEl: '.go-nuxt',
                    prevEl: '.go-pre',
                }
            })
        }
    },
    // Swiper 数据刷新
    refreshSwiperData: function (data,self) {
        let _dom = $('#yingguzhishu').find('.swiper-slide')
        if (data.rc == 0) {
            data.data.diff.forEach((item, index) => {
                _dom[index].innerHTML = `<div class="zs-wrap">
                <a href="/quote/stock/${item.f13}.${item.f12}.html">
                    <p>${item.f14}</p>
                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>${self.numberFix(item.f2,2)}</p>
                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>
                        <span>${self.numberFix(item.f4,2)}</span>
                        <span>${self.dataProcess(item.f3,'%')}</span>
                    </p>
                </a>
            </div>`
            })
        }
    },
    // 绑定沪伦通溢价率数据
    bindHltyj:function(){
        let self = this
        // 沪伦通专题
        $.ajax({
            url: '//push2.eastmoney.com/api/qt/ulist.np/get?ut=bd1d9ddb04089700cf9c27f6f7426281&secids=16001.VIDX_HLTGDR,16001.VIDX_HLTCDR&fields=f104,f105,f106',
            type: 'get',
            dataType: 'json',
            success: function (data) {
                let res = data.data.diff
                let gdrsum = res[0].f104+res[0].f105+res[0].f106
                let cdrsum = res[1].f104+res[1].f105+res[1].f106
                let gdrhtml = `<span>GDR</span><span>${gdrsum == 0 ? '--' : (gdrsum + '家')}</span><span>上涨占比</span><span class=${res[0].f104>0?'gp-asc':''}>${Math.round(res[0].f104/gdrsum*100)+'%'}</span>`
                $('.hlt-gdr').html(gdrhtml)
                let cdrhtml = `<span>CDR</span><span>${cdrsum == 0 ? '--' : (cdrsum + '家')}</span><span>上涨占比</span><span class=${res[1].f104>0?'gp-asc':''}>${cdrsum > 0 ? Math.round(res[1].f104/cdrsum)*100+'%' : '--'}</span>`
                $('.hlt-cdr').html(cdrhtml)
            }
        })

        $.ajax({
            url: '//push2.eastmoney.com/api/qt/clist/get?ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&fs=b:MK0815&np=1&pn=1&pz=1&po=1&fid=f119&fields=f12,f13,f14,f119',
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if(data.data == null){
                  let html = `<span>G/A</span><span>--</span><span>--</span>`
                  $('.yjl-gdr').html(html)
                }else{
                  let res = data.data.diff
                  let html = `<span>G/A</span><span>${res[0].f14}</span><span class=${res[0].f119>0?'gp-asc':(res[0].f119<0?'gp-des':'')}>${res[0].f119+'%'}</span>`
                  $('.yjl-gdr').html(html)
                }
            }
        })

      $.ajax({
          url: '//push2.eastmoney.com/api/qt/clist/get?ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&fs=m:1+e:31&np=1&pn=1&pz=1&po=1&fid=f119&fields=f12,f13,f14,f119',
          type: 'get',
          dataType: 'json',
          success: function (data) {
              if(data.data == null){
                let html = `<span>C/英</span><span>--</span><span>--</span>`
                $('.yjl-cdr').html(html)
              }else{
                let res = data.data.diff
                let html = `<span>C/英</span><span>${res[0].f14}</span><span class=${res[0].f119>0?'gp-asc':(res[0].f119<0?'gp-des':'')}>${res[0].f119+'%'}</span>`
                $('.yjl-cdr').html(html)
              }
          }
      })
    },
    makeList1:function(){
        let self = this
        let List1 = new List({
            ele:'zmyg',
            api:'//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&pn=1&pz=10&fid=f3&po=1&fs=b:MK0794&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 15,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13}.${data.f12}.html">
                        <div>
                            <p>${data.f14}</p>
                            <p>${data.f12}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,3)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,'%')}</div>
                    </a>
                </dd>
                `
            }
        })
        List1.init()
    },
    makeList2:function(){
        let self = this
        let List2 = new List({
            ele:'gdr',
            api:'//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&pn=1&pz=10&fid=f3&po=1&fs=m:156+t:7&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 15,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13}.${data.f12}.html">
                        <div>
                            <p>${data.f14}</p>
                            <p>${data.f12}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,3)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,'%')}</div>
                    </a>
                </dd>
                `
            }
        })
        List2.init()
    },
    makeList3:function(){
        let self = this
        let List3 = new List({
            ele:'lzg',
            api:'//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&pn=1&pz=10&fid=f3&po=1&fs=m:155+t:1,m:156+t:1,m:156+t:5,m:156+t:6,m:156+t:7,m:156+t:8&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 15,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13}.${data.f12}.html">
                        <div>
                            <p>${data.f14}</p>
                            <p>${data.f12}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,3)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,'%')}</div>
                    </a>
                </dd>
                `
            }
        })
        List3.init()
    },
    makeList4:function(){
        let self = this
        let List4 = new List({
            ele:'ldg',
            api:'//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&pn=1&pz=10&fid=f3&po=0&fs=m:155+t:1,m:156+t:1,m:156+t:5,m:156+t:6,m:156+t:7,m:156+t:8&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 15,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13}.${data.f12}.html">
                        <div>
                            <p>${data.f14}</p>
                            <p>${data.f12}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,3)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,'%')}</div>
                    </a>
                </dd>
                `
            }
        })
        List4.init()
    },
    makeList5:function(){
        let self = this
        let List5 = new List({
            ele:'etf',
            api:'//push2.eastmoney.com/api/qt/clist/get?cb=?&np=1&fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&pn=1&pz=10&fid=f3&po=1&fs=m:155+t:3&ut=f057cbcbce2a86e2866ab8877db1d059&forcect=1',
            refresh: 15,
            html:function(data){
                return `
                <dd>
                    <a href="/quote/stock/${data.f13}.${data.f12}.html">
                        <div>
                            <p>${data.f14}</p>
                            <p>${data.f12}</p>
                        </div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.numberFix(data.f2,3)}</div>
                        <div class=${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0 ? 'shares-fall' : '')}>${self.dataProcess(data.f3,'%')}</div>
                    </a>
                </dd>
                `
            }
        })
        List5.init()
    },
    // 页面自刷
    refresh: function () {
        let self = this
        let url = self.getyingguzhishu()
        if (self.refresh_time > 0) {
            clearInterval(self.timer)
            self.timer = setInterval(() => {
              //swiper数据更新
              self.getData(url, self.refreshSwiperData)
              //沪伦通溢价更新
              self.bindHltyj()
            }, self.refresh_time * 1000);
        }
    },
    conversion(num: number, isSign: boolean, isUnit: boolean) {
        let numSign: string
        let self = this
        if (isSign) {
          if (num < 0) {
            numSign = '-'
          } else if (num == 0) {
            numSign = ''
          } else {
            numSign = '+'
          }
        } else {
          numSign = ''
        }
        if (Math.abs(num) == 0) {
          return 0
        } else if (Math.abs(num) > 0 && Math.abs(num) < 1) {
          return numSign + self.numberFix(Math.abs(num), 3)
        } else if (Math.abs(num) >= 1 && Math.abs(num) < 100) {
          return numSign + self.numberFix(Math.abs(num), 2)
        } else if (Math.abs(num) >= 100 && Math.abs(num) < 1000) {
          return numSign + self.numberFix(Math.abs(num), 1)
        } else if (Math.abs(num) >= 1000 && Math.abs(num) < 10000) {
          return numSign + self.numberFix(Math.abs(num), 0)
        } else if (Math.abs(num) >= 10000 && Math.abs(num) < 1000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 10000, 2) + '万'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 10000, 2)
          }
        } else if (Math.abs(num) >= 1000000 && Math.abs(num) < 10000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 10000, 1) + '万'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 10000, 1)
          }
        } else if (Math.abs(num) >= 10000000 && Math.abs(num) < 100000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 10000, 0) + '万'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 10000, 0)
          }
        } else if (Math.abs(num) >= 100000000 && Math.abs(num) < 10000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 2) + '亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 2)
          }
        } else if (Math.abs(num) >= 10000000000 && Math.abs(num) < 100000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 1) + '亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 1)
          }
        } else if (Math.abs(num) >= 100000000000 && Math.abs(num) < 1000000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 0) + '亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 0)
          }
        } else if (Math.abs(num) >= 1000000000000 && Math.abs(num) < 10000000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 1000000000000, 1) + '万亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 1000000000000, 1)
          }
        } else if (Math.abs(num) >= 10000000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 1000000000000, 0) + '万亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 1000000000000, 0)
          }
        }else{
            return '-'
        }
    },
    numberFix(num: number, n: number) {
        var f = parseFloat(String(num));
        if (isNaN(f)) {
          return '-';
        }
        var f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
        if (n == 0) {
          return f
        } else {
          var s = f.toString();
          var rs = s.indexOf('.');
          if (rs < 0) {
            rs = s.length;
            s += '.';
          }
          while (s.length <= rs + n) {
            s += '0';
          }
          return s;
        }
    },
    dataProcess(data,symbol){
        let self = this
        if(data == undefined || data == null || data == '-'){
            return '-'
        }else{
            return self.numberFix(data,2) + symbol
        }
    }
}

data.init()

import {NavScroll} from '../modules/title_scroll'
NavScroll("nav_uk")